import { doPrivatePostRequest } from "./requests"

export const getSummaryByDocId = (_doc_id, _token) => {
    const path = '/meets-summary/get'
    const params = {
        'st': 'DOC-ID',
        'sk': _doc_id,
    }
    return doPrivatePostRequest(params, path, _token)
}

export const getSummaryByMeetsId = (_doc_id, _token) => {
    const path = '/meets-summary/get'
    const params = {
        'st': 'BY-MEETS-ID',
        'sk': _doc_id,
    }
    return doPrivatePostRequest(params, path, _token)
}